import React from "react";
import { Button, Modal } from "react-bootstrap";
import "./modal.scss";

export const DeleteModal = ({
  handleClose,
  show,
  handleDelete,
  selectedTitle,
  selectedId,
}) => {
  return (
    <Modal show={show} onHide={handleClose} centered>
      <Modal.Header closeButton>
        <Modal.Title className="!text-[16px] font-medium">
          {selectedTitle}
        </Modal.Title>
      </Modal.Header>
      <Modal.Body className="!text-[14px]">
        Are you sure you want to delete {selectedTitle}?
      </Modal.Body>
      <Modal.Footer className="flex-nowrap !justify-end !items-start">
        <Button
          className="w-full !rounded-md bg-transparent h-[43px] !max-w-28 !border-b-color text-black !text-sm"
          variant="secondary"
          onClick={handleClose}
        >
          Cancel
        </Button>
        <Button
          className="w-full !rounded-md !max-w-28 !text-sm !bg-primary-blue h-[43px] !border-primary-blue"
          variant="primary"
          onClick={handleDelete}
        >
          Delete
        </Button>
      </Modal.Footer>
    </Modal>
  );
};
